// normalizeSurfaceNodes.js — adapt Spaces analyze node payloads for view renderers

import { getDataSectionName } from 'views/table/utils/tableFieldUtils';

const normalizeString = (value) => String(value || '').trim();

export function normalizeSurfaceNode(node, typeDef) {
  if (!node || typeof node !== 'object') return node;

  const preferredSection = typeDef?.dataSection || getDataSectionName(typeDef?.key);
  const next = { ...node };

  if (preferredSection && next[preferredSection] && typeof next[preferredSection] === 'object') {
    return next;
  }

  const matchingSectionKey = Object.keys(next).find((key) => (
    key.startsWith('data_')
    && preferredSection
    && key.toLowerCase() === preferredSection.toLowerCase()
  ));

  if (matchingSectionKey && typeof next[matchingSectionKey] === 'object') {
    next[preferredSection] = next[matchingSectionKey];
    return next;
  }

  const fallbackSectionKey = Object.keys(next).find((key) => (
    key.startsWith('data_') && typeof next[key] === 'object' && !Array.isArray(next[key])
  ));

  if (fallbackSectionKey) {
    const targetSection = preferredSection || fallbackSectionKey;
    next[targetSection] = next[fallbackSectionKey];
    return next;
  }

  if (next.values && typeof next.values === 'object' && !Array.isArray(next.values)) {
    const values = next.values;
    const nestedSection = Object.values(values).find((entry) => (
      entry && typeof entry === 'object' && !Array.isArray(entry)
    ));

    if (nestedSection && preferredSection) {
      next[preferredSection] = { ...nestedSection };
      return next;
    }

    if (preferredSection) {
      next[preferredSection] = { ...values };
    }
  }

  return next;
}

export function normalizeSurfaceNodes(nodes, typeDef) {
  return (Array.isArray(nodes) ? nodes : []).map((node) => normalizeSurfaceNode(node, typeDef));
}

export function resolveSurfaceTypeKey(typeDef, surface) {
  return normalizeString(typeDef?.key)
    || normalizeString(surface?.typeId)
    || normalizeString(surface?.plan?.query?.typeId);
}
